import MaterialAssessmentSurveyBase from '../../../components/MaterialAssessmentSurveyBase/MaterialAssessmentSurveyBase';
import { MATERIAL_ASSESSMENT_PAGE_CONFIGS } from '../../../constants/materialAssessment';

function MaterialityAssessmentInterview() {
  return <MaterialAssessmentSurveyBase config={MATERIAL_ASSESSMENT_PAGE_CONFIGS.INTERVIEW} />;
}

export default MaterialityAssessmentInterview;
